import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<label for={{@id}} class={{this.className}} role=\"button\">\n  {{yield}}\n</label>\n<input id={{@id}} type=\"file\" class=\"screen-reader-only\" value={{this.files}} {{on \"change\" this.handleChange}} ...attributes />", {
  moduleName: "@1024pix/pix-ui/components/pix-button-upload.hbs"
});